export default "__VITE_ASSET__DKU7ylHZ__"